/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { deliveryCourierSchema } from "./deliveryCourierSchema.ts";
import { deliveryStageSchema } from "./deliveryStageSchema.ts";
import { kindEnumSchema } from "./kindEnumSchema.ts";
import { stageEnumSchema } from "./stageEnumSchema.ts";

export const deliveryOrderSchema = z.object({
	order_id: z.uuid(),
	status: z.string(),
	total_cost: z.number(),
	delivery_cost: z.number().nullable().describe("Стоимость доставки, оплачивается сверх суммы заказа."),
	kind: kindEnumSchema.describe("* `courier` - Доставка курьером\n* `pickup` - Самовывоз"),
	number: z.int().nullable().describe("Номер заказа, он же код получения."),
	stage: stageEnumSchema.describe(
		"* `waiting_payment` - Ожидает оплаты\n* `accepted` - Принят\n* `cooking` - Готовится\n* `ready` - Собран\n* `on_way` - Курьер в пути\n* `delivered` - Доставлен\n* `completed` - Выдан\n* `cancelled` - Отменён\n* `failed` - Не удалось оформить",
	),
	stages: z.array(deliveryStageSchema),
	eta: z.string().nullable().describe("Ожидаемое время доставки или готовности, местное время точки."),
	can_cancel: z.boolean(),
	courier: deliveryCourierSchema.nullable(),
	tracking_link: z.url().max(500).optional(),
	city: z.string().max(60).optional(),
	flat: z.string().max(10).optional(),
	entrance: z.string().max(10).optional(),
	floor: z.string().max(10).optional(),
	doorphone: z.string().max(10).optional(),
	line1: z.string().max(250).optional(),
	address_comment: z.string().max(500).optional(),
	latitude: z.number().nullish(),
	longitude: z.number().nullish(),
	comment: z.string().max(500).optional(),
	persons: z.int().min(0).max(32767).optional(),
	complete_before: z.string().nullable().describe("Ко времени в местном времени точки; пусто — как можно скорее."),
	zone: z.string().max(255).optional(),
	duration_minutes: z.int().min(0).max(2147483647).nullish(),
});
